import { MarkerItem } from './types'

export const markerItems: MarkerItem[] = [
  {
    id: '0',
    color: '#C871FE',
    text: 'Повышенный тариф и поддержка на выбор',
    caption: 'Субсидия или гарантия дохода',
    coordinates: { xPercent: 60, yPercent: 50 },
    mobileCoordinates: { xPercent: 55, yPercent: 45 },
  },
  {
    id: '1',
    color: '#F983E4',
    text: 'Повышенный тариф и субсидия',
    caption: 'Разовая выплата, когда оборот пункта достигнет 3 млн ₽',
    coordinates: { xPercent: 60, yPercent: 15 },
    mobileCoordinates: { xPercent: 55, yPercent: 8 },
  },
  {
    id: '2',
    color: '#BD54B9',
    text: 'Повышенный тариф и гарантия дохода',
    caption: 'Доплатим, если доход будет меньше суммы на карте',
    coordinates: { xPercent: 33, yPercent: 60 },
    mobileCoordinates: { xPercent: 35, yPercent: 50 },
  },
  {
    id: '3',
    color: '#DDCCFF',
    text: 'Повышенный тариф',
    caption: 'Процент от оборота выше обычного',
    coordinates: { xPercent: 35, yPercent: 25 },
    mobileCoordinates: { xPercent: 35, yPercent: 20 },
  },
]
